import * as React from "react";
import {Navigate} from "react-router-dom";

import {MATCHERS_ROUTES, PRODUCTS_MATCHER_ROUTES, RAW_MATCHER_ROUTES, REVERSE_MATCHER_ROUTES, USER_ROLE} from "@constants";
import {useUserApp} from "@hooks";
import AppLayout from "Layout";
import MatchersSKUsPage from "./skus";
import ReverseMatcherPage from "./Reverse";
import RawMatcherPage from "./Raw";
import ProductsMatcherPage from "./Products";

// Smart redirect based on user role
const RootRedirect = () => {
	const { userRole } = useUserApp()
	const target = userRole === 'reverse'
		? REVERSE_MATCHER_ROUTES.REVERSE_PATH
		: MATCHERS_ROUTES.SKUS_PATH
	return <Navigate to={target} replace />
}

export const MatchersRoutes = [{
	path: "/",
	element: <RootRedirect />, index: true
}, {
	path: MATCHERS_ROUTES.PATH,
	title: "SKU Mapping",
	icon: 'diagram-project',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'Map products directly from SKU_MAPPING',
	access: USER_ROLE.STANDARD,
	children: [{
		element: <Navigate to={MATCHERS_ROUTES.SKUS_PATH} replace />, index: true
	}, {
		path: MATCHERS_ROUTES.SKUS_PATH,
		element: <MatchersSKUsPage />
	}]
}, {
	path: REVERSE_MATCHER_ROUTES.PATH,
	title: "SKU to Product",
	icon: 'arrow-left-from-bracket',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'Map SKUs to retailer products',
	access: [USER_ROLE.REVERSE, USER_ROLE.STANDARD],
	children: [{
		element: <Navigate to={REVERSE_MATCHER_ROUTES.REVERSE_PATH} replace />, index: true
	}, {
		path: "/matcher/brands",
		element: <Navigate to={REVERSE_MATCHER_ROUTES.REVERSE_PATH} replace />,
		index: true
	}, {
		path: REVERSE_MATCHER_ROUTES.REVERSE_PATH,
		element: <ReverseMatcherPage />
	}]
}, {
	path: RAW_MATCHER_ROUTES.PATH,
	title: "Product to SKU",
	icon: 'arrow-right-from-bracket',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'Map raw products to SKUs',
	access: USER_ROLE.STANDARD,
	children: [{
		element: <Navigate to={RAW_MATCHER_ROUTES.RAW_PATH} replace />, index: true
	}, {
		path: RAW_MATCHER_ROUTES.RAW_PATH,
		element: <RawMatcherPage />
	}]
}, {
	path: PRODUCTS_MATCHER_ROUTES.PATH,
	title: "Raw to Raw",
	icon: 'arrows-left-right',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'Match own products to competitor products (raw2raw)',
	access: USER_ROLE.STANDARD,
	children: [{
		element: <Navigate to={PRODUCTS_MATCHER_ROUTES.PRODUCTS_PATH} replace />, index: true
	}, {
		path: PRODUCTS_MATCHER_ROUTES.PRODUCTS_PATH,
		element: <ProductsMatcherPage />
	}]
}]